import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  array,
  boolean,
  type InferOutput,
  number,
  object,
  optional,
  parse,
  string
} from 'valibot'

import { buildFetchPartnerUserQuery } from '@/features/users'
import { fetchPartnerUsers } from '@/features/users/api'

import { PartnerUsersSearchSchema } from './-models/partner-users-search'

const PartnerUsersSchema = object({
  page: optional(number()),
  take: optional(number()),
  displayName: optional(string()),
  partnerIds: optional(array(number())),
  enable: optional(boolean())
})

export type PartnerUsersSearch = InferOutput<typeof PartnerUsersSchema>

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/_users/partner-users/'
)({
  validateSearch: (search) => parse(PartnerUsersSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス(クエリが空)の場合は、enable=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          enable: true
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchPartnerUserQuery(tenantKey, deps)

    return {
      authUser: auth.user,
      users: await fetchPartnerUsers(query, abortController.signal)
    }
  }
})
